module.exports = __webpack_public_path__ + "static/media/boss-bar-yellow-07.f2f86fc5.png";